import React from "react";
import { FontAwesomeIcon, Props } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/pro-solid-svg-icons";
import { DefaultIconStyle } from "./styles";

export function IconUsers(props: Partial<Props>): React.ReactElement {
  return <FontAwesomeIcon style={DefaultIconStyle} {...props} icon={faUsers} />;
}
